/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import FadeIn from '@atlaskit/motion/fade-in';
import { token } from '@atlaskit/tokens';

const skeletonWrapperStyles = css({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	'@media (prefers-reduced-motion: reduce)': {
		animation: 'none',
		transition: 'none',
	},
});

const emojiSkeletonStyles = css({
	display: 'inline-block',
	backgroundColor: token('color.skeleton'),
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
	marginTop: token('space.0'),
	marginRight: token('space.0'),
	marginBottom: token('space.0'),
	marginLeft: token('space.0'),
	paddingTop: token('space.0'),
});

type EmojiPlaceholderProps = {
	height: number;
	loadingMargin?: string;
};

export const EmojiPlaceholder = ({ height, loadingMargin }: EmojiPlaceholderProps): JSX.Element => {
	const PLACEHOLDER_SIZE = height;
	return (
		<FadeIn entranceDirection="left">
			{(animationProps) => (
				<span
					css={skeletonWrapperStyles}
					{...animationProps}
					data-testid="emoji-placeholder"
					data-css-target="emoji-placeholder"
				>
					<span
						css={[emojiSkeletonStyles]}
						style={{
							width: `${PLACEHOLDER_SIZE}px`,
							height: `${PLACEHOLDER_SIZE}px`,
							margin: loadingMargin,
						}}
					/>
				</span>
			)}
		</FadeIn>
	);
};
